import { resolveResponsiveProp } from '../../internal/responsive-props';
import styles from './useNegativeMargin.module.less';
export var useNegativeMarginTop = function useNegativeMarginTop(spacing) {
  return resolveResponsiveProp(spacing, 'negative-margin-top', styles);
};
export var useNegativeMarginLeft = function useNegativeMarginLeft(spacing) {
  return resolveResponsiveProp(spacing, 'negative-margin-left', styles);
};